/* eslint-disable react/prop-types */
import { FC } from "react";
import { Bell, Smartphone } from "lucide-react";

interface Props {
	pushTitle: string;
	pushBody: string;
	appName?: string;
}

const PushPreviewPanel: FC<Props> = ({
	pushTitle,
	pushBody,
	appName = "Mee"
}) => {
	const displayTitle = pushTitle || "Notification title";
	const displayBody = pushBody || "Notification body text will appear here";

	return (
		<div>
			<p className="text-sm font-medium text-zinc-600 mb-2">Preview</p>

			<div className="w-[280px]">
				<div className="bg-zinc-900 rounded-t-2xl px-4 py-2 flex items-center justify-between">
					<span className="text-white text-xs font-medium">9:41</span>
					<div className="flex items-center gap-1">
						<Smartphone className="h-3 w-3 text-white" />
					</div>
				</div>
				<div className="bg-zinc-900 px-3 pb-4 rounded-b-2xl">
					<div className="rounded-2xl p-3 shadow-sm bg-white/95 backdrop-blur-sm">
						<div className="flex items-center gap-2 mb-1.5">
							<div className="w-5 h-5 rounded-md bg-primary flex items-center justify-center">
								<Bell className="h-3 w-3 text-white" />
							</div>
							<span className="text-xs font-medium uppercase tracking-wide text-zinc-400">
								{appName}
							</span>
							<span className="text-xs ml-auto text-zinc-400">now</span>
						</div>
						<p className="text-sm font-semibold leading-tight line-clamp-1 text-foreground">
							{displayTitle}
						</p>
						<p className="text-sm leading-snug mt-0.5 line-clamp-2 text-muted-foreground">
							{displayBody}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PushPreviewPanel;
